import { combineReducers } from 'redux';
import errorReducer from './errorReducer';
import facebookUserReducer from './facebookUserReducer';
import loadingReducer from './loadingReducer';
import pageFacebookReducer from './pageFacebookReducer';
import pageReducer from './pageReducer';
import pagesReducer from './pagesReducer';
import settingPapgeReducer from './settingPapgeReducer';
import subMenuReducer from './subMenuReducer';
import campaignsReducer from './campaignsReducer';
import postReducer from './postReducer';
import campaignReducer from './campaignReducer';
import productsReducer from './productsReducer';
import cartReducer from './cartReducer';
import addressReducer from './addressReducer';
import orderReducer from './orderReducer';
import paymentReducer from './paymentReducer';
import userReducer from './userReducer';
import commentPostReducer from './commentPostReducer';
import faqReducer from './faqReducer';
import buttonLoadingReducer from './buttonLoadingReducer';
import globalReducer from './globalReducer';
import messageSettingGeneralReducer from './messageSettingGeneralReducer';
import settingWelcomeMessageReducer from './settingWelcomeMessageReducer';
import modalReducer from './modalReducer';
import liveCampaignReducer from './liveCampaignReducer';
import postLiveReducer from './postLiveReducer';
import commentReducer from './commentReducer';
import customerReducer from './customerReducer';
import conversationReducer from './conversationReducer';
import generalSettingsReducer from './generalSettingsReducer';
import audiencesReducer from './audiencesReducer';
import warehouseReducer from './warehouseReducer';

export default combineReducers({
   address: addressReducer,
   campaign: campaignReducer,
   campaigns: campaignsReducer,
   carts: cartReducer,
   error: errorReducer,
   facebookUser: facebookUserReducer,
   loading: loadingReducer,
   buttonLoading: buttonLoadingReducer,
   order: orderReducer,
   pageFacebook: pageFacebookReducer,
   page: pageReducer,
   pages: pagesReducer,
   payments: paymentReducer,
   posts: postReducer,
   products: productsReducer,
   settingPage: settingPapgeReducer,
   subMenus: subMenuReducer,
   user: userReducer,
   commentPosts: commentPostReducer,
   faq: faqReducer,
   global: globalReducer,
   messageSettingGeneral: messageSettingGeneralReducer,
   settingWelcomeMessage: settingWelcomeMessageReducer,
   modal: modalReducer,
   liveCampaign: liveCampaignReducer,
   postLive: postLiveReducer,
   comments: commentReducer,
   customers: customerReducer,
   conversation: conversationReducer,
   generalSettings: generalSettingsReducer,
   audiences: audiencesReducer,
   warehouses: warehouseReducer,
});